/*
 *
 * PayBalance actions
 *
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import {
  rootApiResponse,
  clearDefaultError,
} from '../HeaderContainer/actions';
import {
  isImmutableLoggedIn,
  successResponse,
  errorResponse,
  // addAuthHeaders,
  // removeAuthHeaders,
} from '../../devUtils/commonUtils';
import {
  PAY_BALANCE_CONSTANT,
  FETCH_PAY_BALANCE_SUCCESS,
  DEFAULT_ACTION,
  ADD_CARD_SUCCESS,
  OTP_SUBMIT,
} from './constants';
import { utils, constants, eventTracking } from '../../devUtils';

const fetchPayBalanceSuccess = (payload) => ({ type: FETCH_PAY_BALANCE_SUCCESS, payload });
const successActionData = (payload) => ({ type: ADD_CARD_SUCCESS, payload });
const FetchWalletBalanceSuccess = (payload) => ({ type: PAY_BALANCE_CONSTANT.SET_WALLET_BALLANCE, payload });
const setNSDLWalletBalance = (payload) => ({ type: PAY_BALANCE_CONSTANT.SET_NSDL_WALLET_BALLANCE, payload });
const inititateKycSucess = (payload) => ({ type: PAY_BALANCE_CONSTANT.XML_M2P_KYC_SUCCESS, payload });
const fetchYblOtpSuccess = (payload) => ({ type: PAY_BALANCE_CONSTANT.SET_YBL_OTP_SUCCESS, payload });
const fetchYblOtpVerifySuccess = (payload) => ({ type: PAY_BALANCE_CONSTANT.SET_YBL_OTP_VERIFIED, payload });

export const otpSubmitAction = (payload) => ({ type: OTP_SUBMIT, payload });
const defaultAction = (payload = true) => ({ type: DEFAULT_ACTION, payload });

async function getYscDetailPromise(_api, item, authPrerequist) {
  const promise = await reqHandler.postHandler(_api, endpoint.GET_YSC_CARD_DETAIL, { ysc_card_id: item.id }, authPrerequist);
  return { ...item, ...promise };
}

const handleYSCPromises = (res, total_balance, promiseArray) => (dispatch) => {
  Promise.all(promiseArray.map((item) => item.catch((err) => err)))
    .then((arrayOfValuesOrErrors) => {
      const values = utils.lodashFilter(arrayOfValuesOrErrors, utils.lodashIsObject); // filter only array
      res.yscs = values;
      res.total_balance = total_balance;
      dispatch(fetchPayBalanceSuccess(res));
    })
    .catch((err) => {
      res.yscs = [];
      res.total_balance = '- -';
      dispatch(fetchPayBalanceSuccess(res));
      dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, constants.ALERT_DEFAULT)));
      return { isSuccess: false, data: err };
    });
};

export const fetchPayBalance = () => async (dispatch, getState, api) => {
  try {
    dispatch(clearDefaultError());
    const _api = api;
    const loggedIn = isImmutableLoggedIn(getState);
    if (loggedIn) {
      const authPrerequist = utils.getAuthPrerequist(getState, true);
      const res = await reqHandler.getHandler(_api, endpoint.GET_PAY_BALANCE, null, authPrerequist);
      if (res) {
        const { yscs: _yscs, expense_cards = [] } = res;
        let yscs = _yscs.concat(expense_cards);
        const { total_balance, min_kyc_required } = res;
        yscs = yscs.map((item) => getYscDetailPromise(_api, item, authPrerequist));
        dispatch(handleYSCPromises(res, total_balance, yscs));
        res.yscs = yscs && yscs.length ? [{ isLoading: true, index: 0 }] : [];
        res.total_balance = '- -';
        res.min_kyc_required = min_kyc_required;
        dispatch(fetchPayBalanceSuccess(res));
      } else {
        throw (constants.ALERT_DEFAULT);
      }
    } else {
      throw (constants.ALERT_LOGIN_REQUIRED);
    }
  } catch (err) {
    dispatch(defaultAction(false));
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

export const addZaggleCardAction = (payload) => async (dispatch, getState, api) => {
  const category = payload.type === 'ZSC' ? 'Redeem ZSC' : 'Manage Network Cards';
  const actionType = payload.type === 'ZSC' ? 'Add ZSC on Pay balance' : 'Add Card';
  try {
    dispatch(clearDefaultError());
    dispatch(defaultAction());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const cart_obj = await reqHandler.postHandler(api, endpoint.ADD_CARD, payload.card_obj, authPrerequist);
    // Older Coder condition
    // if (payload.type === 'ZSC' && cart_obj.zaggle_card) {
    //   dispatch(successActionData(cart_obj));
    //   dispatch(fetchPayBalance());
    //   dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, constants.ALERT_ZSC_ADDED)));
    //   eventTracking.triggerEvent(category, actionType, 'Success');
    // }
    if (payload.type === 'ZSC' && cart_obj) {
      dispatch(successActionData(cart_obj));
      if (cart_obj.zaggle_card) {
        dispatch(fetchPayBalance());
        dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, constants.ALERT_ZSC_ADDED)));
      }
      eventTracking.triggerEvent(category, actionType, 'Success');
    } else if (cart_obj.ysc_card_id) {
      dispatch(successActionData(cart_obj));
      dispatch(fetchPayBalance());
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, cart_obj.message, 'popup')));
      eventTracking.triggerEvent(category, actionType, 'YSC Card/Success');
    } else {
      throw (cart_obj.message);
    }
  } catch (err) {
    const { type, defaultStatus = true } = payload;
    dispatch(defaultAction(false));
    if (type === 'ZSC' && defaultStatus) {
      dispatch(successActionData({ status: false }));
    }
    eventTracking.triggerEvent(category, actionType, type === 'ZSC' ? 'Failure' : 'YSC Card/Failure');
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

/**
 * @param {*contains type of request} payload
 * @param {handling multiple cases}  isNetworkCardModule/paybalance also
 * {"message":"Reason should be alphanumeric only."}
 */
export const submitOtp = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const otp_res = await reqHandler.postHandler(api, endpoint.VERIFY_OTP, payload, authPrerequist);
    if (otp_res.errors && otp_res.errors.length > 0) {
      throw (otp_res.message);
    } else {
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, otp_res.message)));
      await new Promise((resolve) => setTimeout(resolve, 1000));
      dispatch(otpSubmitAction(otp_res));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const FetchWalletBalance = (payload, otherParams = {}) => async (dispatch, getState, api) => {
  try {
    const { cardType = '' } = otherParams;
    dispatch(clearDefaultError());
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const URL = cardType === 'nsdl' ? endpoint.GET_WALLET_M2P_BALANCE : endpoint.GET_WALLET_BALANCE_V3;
    const response = await reqHandler.getHandler(api, URL, payload, authPrerequist);
    if (response && response.status) {
      if (cardType === 'nsdl') {
        return dispatch(setNSDLWalletBalance(response));
      }
      dispatch(FetchWalletBalanceSuccess(response));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw (response.message);
  } catch (err) {
    dispatch({ type: PAY_BALANCE_CONSTANT.SET_WALLET_BALLANCE, payload: {} });
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};

const inititateKycProcess = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(clearDefaultError());
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.getHandler(api, endpoint.GET_INITITATE_M2P_KYC, payload, authPrerequist);
    dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, response.message)));
    await new Promise((resolve) => setTimeout(resolve, 3000));
    return dispatch(inititateKycSucess(response));
  } catch (err) {
    dispatch({ type: PAY_BALANCE_CONSTANT.SET_WALLET_BALLANCE, payload: {} });
    return dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
  }
};
const generateYscOtp = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(clearDefaultError());
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_GENERATE_YSC_OTP, payload, authPrerequist);
    if (response) {
      dispatch({ type: PAY_BALANCE_CONSTANT.SET_GENERATE_OTP_YSC, payload: { response } });
      dispatch(rootApiResponse(successResponse(DEFAULT_ACTION, response.message)));
      return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    }
    throw response.message;
  } catch (err) {
    dispatch(rootApiResponse(errorResponse(DEFAULT_ACTION, err)));
    return dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  }
};

const yblOtpGeneration = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_WALLET_REGISTER, payload, authPrerequist);
    if (response && response.status) {
      dispatch(fetchYblOtpSuccess(response));
      return dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, response.message)));
    }
    throw (response.message);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};

const yblOtpVerify = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.postHandler(api, endpoint.POST_WALLET_VERIFY_OTP, payload, authPrerequist);
    if (response && response.status) {
      dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, response.message)));
      await new Promise((resolve) => setTimeout(resolve, 3000));
      return dispatch(fetchYblOtpVerifySuccess(response));
    }
    throw (response.message);
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    return dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};

export { FetchWalletBalance, FetchWalletBalanceSuccess, inititateKycProcess, generateYscOtp, yblOtpGeneration, yblOtpVerify };



// WEBPACK FOOTER //
// client/containers/PayBalance/actions.js